import RELO_BLACK from "./logos/reloLogo.svg";
import CRI_CITY_LOGO from "./logos/criCityLogo.svg";

const logos = {
  RELO_BLACK,
  CRI_CITY_LOGO,
};

export default logos;
